import axios from 'axios';

export default {
  getAbTestings({ commit, state }, { ctx, filter }) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/abtesting/get`,
        params: { ...ctx, ...filter },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('insertAbTesting', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addAbTesting({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      commit('addAbTestingRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/abtesting/add`,
        data: ctx,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('addAbTestingRequestSuccess', resp.data);
          resolve(resp);
        })
        .catch(err => {
          commit('addAbTestingRequestError', err);
          reject(err);
        });
    });
  },
  editAbTesting({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      commit('editAbTestingRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/abtesting/edit`,
        data: ctx,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('editAbTestingRequestSuccess', resp.data);
          resolve(resp);
        })
        .catch(err => {
          commit('editAbTestingRequestError', err);
          reject(err);
        });
    });
  },
  removeAbTesting({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      commit('removeAbTestingRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/abtesting/destroy`,
        data: ctx,
        method: 'DELETE'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('removeAbTestingRequestSuccess', ctx);
          resolve(resp);
        })
        .catch(err => {
          commit('removeAbTestingRequestError', err);
          reject(err);
        });
    });
  },
  changeAbTestingIsActive({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      commit('changeAbTestingIsActiveRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/abtesting/changeIsActive`,
        data: ctx,
        method: 'POST'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error(resp.data.message));
            return;
          }
          commit('changeAbTestingIsActiveRequestSuccess', ctx);
          resolve(resp);
        })
        .catch(err => {
          commit('changeAbTestingIsActiveRequestError', err);
          reject(err);
        });
    });
  }
};
